import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { KnBrInvoiceAccountSummaryComponent } from './kn-br-invoice-account-summary.component';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        KnBrCustomPipesModule,
        ConfigModule.withConfig({
            cmsComponents: {
                'KnBrInvoiceHeaderComponent-due-balance': {
                    component: KnBrInvoiceAccountSummaryComponent,
                },
            },
        } as CmsConfig),
        KnBrInvoiceAccountSummaryComponent,
    ],
})
export class KnBrInvoiceAccountSummaryModule {}
